module.exports = __webpack_public_path__ + "img/browsers-inception-2.1ff67a3e.png";